import React from 'react';
import { Redirect } from 'react-router-dom';
import Loading from '../../components/loading';
import { LOGIN_FROM } from '../../constants';
import { connect } from 'react-redux';
import store from 'store';

function LoginReturn(props) {
    const { isLogin, loading } = props;
    if (loading) {
        return <div><Loading /></div>;
    } else if (isLogin) {
        const from = store.get(LOGIN_FROM);
        return <Redirect to={from} />;
    } else {
        return <Redirect to="/login" />;
    }
}

const mapStateToProps = state => ({
    ...state.user
});

export default connect(
    mapStateToProps
)(LoginReturn);


// WEBPACK FOOTER //
// ./src/containers/login/loginReturn.jsx